import { render, staticRenderFns } from "./PageViewer.vue?vue&type=template&id=0dc24b4b&scoped=true"
import script from "./PageViewer.vue?vue&type=script&lang=js"
export * from "./PageViewer.vue?vue&type=script&lang=js"
import style0 from "./PageViewer.vue?vue&type=style&index=0&id=0dc24b4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc24b4b",
  null
  
)

export default component.exports